import { useCallback } from "react";

import { Flex, useAudio } from "@aircall/tractor";

import { speedOptions } from "./PlayerSpeedControls.constants";
import { SpeedButton } from "./SpeedButton";
import { SpeedPicker } from "./SpeedPicker";

import { useTrackAudioSpeed } from "@/hooks/useTrackAudioSpeed/useTrackAudioSpeed";
import { useBaseStore } from "@/store/store";

export function PlayerSpeedControls() {
  const isExpanded = useBaseStore((store) => store.isExpanded);

  const trackAudioSpeed = useTrackAudioSpeed();

  const { setSpeed, speed } = useAudio();

  const onSpeedChange = useCallback(
    (v: number) => {
      setSpeed(v);
      trackAudioSpeed(v);
    },
    [setSpeed, trackAudioSpeed]
  );

  return isExpanded ? (
    <Flex
      alignItems="center"
      justifyContent="start"
      data-test="speed-configuration"
    >
      {speedOptions.map((o) => (
        <SpeedButton
          key={o.val}
          isActive={o.val === speed}
          onClick={() => {
            onSpeedChange(o.val);
          }}
        >
          {o.label}
        </SpeedButton>
      ))}
    </Flex>
  ) : (
    <SpeedPicker value={speed} onChange={onSpeedChange} />
  );
}
